import "./Login.scss";
import { FC, PropsWithChildren } from "react";

const IconContainer: FC<PropsWithChildren> = props => (
  <span className="icon-container">{props.children}</span>
);

export default IconContainer;
